import $ from 'jquery'


$(window).on('scroll', () => {
  let st = $(window).scrollTop();
  let offset = Number($('#totop').data('offset')) || 500;

  if (st > offset) {
    $('#totop').addClass('is-visible');
  } else {
    $('#totop').removeClass('is-visible');
  }
});

$('#totop').on('click', ()  => {
  $("html, body").stop().animate({scrollTop:0}, '300', 'swing');
});



// WEBPACK FOOTER //
// ./src/js/components/totop.js